import $ from 'jquery';
import listService      from 'ListService';
import constants        from 'Constants';
import utils  from 'util/Util.js';
import BaseDashboardLeftPanelView from 'dashboard/BaseDashboardLeftPanelView';
import RestService from 'RestService';
import UserService from 'UserService';
import NotificationService from 'NotificationService';
import CustomListController from 'CustomListController';
import ServiceURLController from 'ServiceURLController';
import EmailServerController from 'EmailServerController';
import UserController from 'UserController';
import SettingsLicenseView from 'dashboard/settings/SettingsLicenseView';
import UserSearchDetailView from 'dashboard/settings/UserSearchDetailView';
import UserDetailsView from 'dashboard/settings/UserDetailsView';
import AccountSettingsView from 'dashboard/settings/AccountSettingsView';
import NewArchiveDetailsView from 'dashboard/settings/NewArchiveDetailsView';
import UserGroupSearchDetailView from 'dashboard/settings/UserGroupSearchDetailView';
import UserGroupDetailsView from 'dashboard/settings/UserGroupDetailsView';
import EmailServerDetailsView from 'dashboard/settings/EmailServerDetailsView';
import SourceURLTableView from 'dashboard/settings/SourceURLTableView';
import PersonalDetailsView from 'dashboard/settings/PersonalDetailsView';
import ListDetailsView from 'dashboard/settings/ListDetailsView';
import SynchronizeDetailsView from 'dashboard/settings/SynchronizeDetailsView';
import UserPositionDetailsView from 'dashboard/settings/UserPositionDetailsView';
import PositionSearchDetailView from 'dashboard/settings/PositionSearchDetailView';
import UserSettingsModel from 'UserSettingsModel';
import AccountSettingsModel from 'AccountSettingsModel';
import UserDetailsModel from 'UserDetailsModel';
import EmailServerDetailsModel from 'EmailServerDetailsModel';
import PersonalDetailsModel from 'PersonalDetailsModel';
import ListDetailsModel from 'ListDetailsModel';
import NewArchiveModel from 'NewArchiveModel';
import SynchronizationProfileModel from 'SynchronizationProfileModel';
import UserPositionDetailsModel from 'UserPositionDetailsModel';
import PositionsModel from 'PositionsModel'
import dashboardService     from 'DashboardService';
import eventBus from 'EventBus';
import userService from "UserService";
import util from 'util/Util.js';
import { Model } from 'backbone';
import restMessages from 'RestMessages';

const ICON_SYNCRONIZE = constants.DB_ICON_SYNCRONIZE;
const ICON_FOLDER = constants.DB_ICON_FOLDER;
const ICON_EMPTY = constants.DB_ICON_EMPTY;

class SettingsLeftPanelView extends BaseDashboardLeftPanelView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};

        // Most Events Should be at Base
        //this.events = {};

        const perDetails={
            nodeName: 'Personal Details',
            url: '#',
            icon: ICON_EMPTY,
            id: 0,
            groupType: constants.SETTINGS_PERSONAL_GROUP_TYPE,
            nodeType: 'personalDetails',
            hasChildren: false,
            toggleIcon: '',
            nodes: []
        };

        // structure to load List
        const sections = {
            sections: [
                {
                    sectionName: 'Account Settings',
                    sectionType: 'sectionAccountSettings',
                    groupType: 'section',
                    id: 0,
                    nodeType: 'none',
                    groups: [{
                            groupName: 'Users',
                            nodeType: 'Users',
                            id: constants.SETTINGS_USERS_GROUP_TYPE,
                            nodes: []
                        },
                        {
                            groupName: 'Resources',
                            nodeType: 'Resources',
                            id: constants.SETTINGS_RESOURCES_GROUP_TYPE,
                            nodes: []
                        }],
                    nodes: [
                        {
                            nodeName: 'Account Details', // PF-1791
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: '',
                            nodeType: 'settings',
                            hasChildren: false,
                            toggleIcon: '',
                            nodes: []
                        },
                        {
                            nodeName: 'License',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: '',
                            nodeType: 'license',
                            hasChildren: false,
                            toggleIcon: '',
                            nodes: []
                        }
                    ]
                },
                {
                    sectionName: 'Archive Settings',
                    sectionType: 'sectionArchiveSettings',
                    groupType: 'section',
                    id: constants.SETTINGS_ARCHIVE_GROUP_TYPE,
                    nodeType: 'none',
                    groups: [],
                    nodes: [
                        {
                            nodeName: 'New Archive',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: '',
                            nodeType: 'newArchive',
                            hasChildren: false,
                            toggleIcon: '',
                            nodes: []
                        },
                        {
                            nodeName: 'Archived Instances',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: '',
                            nodeType: 'archivedInstances',
                            hasChildren: false,
                            toggleIcon: '',
                            nodes: []
                        }]
                },
                {
                    sectionName: 'Personal Settings',
                    sectionType: 'sectionPersonalSettings',
                    nodeType: 'none',
                    id: constants.SETTINGS_PERSONAL_GROUP_TYPE,
                    groups: [],
                    nodes: [perDetails]

                }
            ]
        };

        // PF-3911: Prune section node(s) according to administrative archive setting
        const prunedSections = (s => {
            const
                isArchivingEnabled = listService.accountSettings ? utils.isTrue(listService.accountSettings['ArchivingEnabled']) : false,
                sections = [],
                keys = isArchivingEnabled ? [0, 1, 2] : [0, 2];

            keys.forEach(k => sections.push(s.sections[k]));

            return {sections: sections}
        })(sections);

        this.model.set('settingsSections', prunedSections, {silent: true});
        this.model.set('perDetails', perDetails, {silent: true});

        this.model.set('currentActiveSection', 'settingsSections', {silent: true});

//        this.listenTo(this.model, 'change', this.render);
        this.listenTo(eventBus, constants.SWITCH_DETAIL_USER, this._onDetailUserSwitch);
        this.listenTo(eventBus, constants.SWITCH_DETAIL_POSITION, this._onDetailPositionSwitch);
        this.listenTo(eventBus, constants.UPDATE_USER_TREEVIEW, this._onUpdateUserOnTreeview);
        this.listenTo(eventBus, constants.UPDATE_USER_POSITION_TREEVIEW, this._onUpdateUserPositionOnTreeview);
        this.listenTo(eventBus, constants.UPDATE_USER_GROUP_TREEVIEW, this._onUpdateUserGroupsOnTreeview);
        this.listenTo(eventBus, constants.USER_GROUP_DELETED, this._onDeletedUserGroup);
        this.listenTo(eventBus, constants.USER_POSITION_DELETED, this._onDeletedPosition);
        this.listenTo(eventBus, constants.EV_DELETE_USER, this.onUserDeleted);
        this.listenTo(eventBus, constants.EV_DELETE_USER_GROUP, this._onDeleting);
        this.listenTo(eventBus, constants.EV_DELETE_USER_POSITION, this._onDeleting);
        this.listenTo(eventBus, constants.EV_UPDATED_ACCOUNT_SETTINGS, this.renderAccountDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_LICENSE_DETAILS, this.renderAccountLicenseView);
        this.listenTo(eventBus, constants.EV_UPDATE_EMAIL_SERVER_DETAILS, this.renderUpdatedServerDetails);
        this.listenTo(eventBus, constants.EV_DELETE_EMAIL_SERVER, this.onEmailServerDeleted);
        this.listenTo(eventBus, constants.EV_DELETE_CUSTOM_LIST, this.onCustomListDeleted);
        this.listenTo(eventBus, constants.EV_UPDATE_PERSONAL_DETAILS, this.renderPersonalDetailsView);
        this.listenTo(eventBus, constants.EV_UPDATE_CUSTOM_LIST_DETAILS, this.renderListDetailsView);
        this.listenTo(eventBus, constants.EV_UPDATE_EXPAND_CUSTOM_LIST_DETAILS, this.renderExpandListDetailsView);
        this.listenTo(eventBus, constants.EV_UPDATED_SYNCHRONIZATION_PROFILE, this.renderSynchronizeDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_USER_NODES_AND_DETAIL, this.refreshUserNodesAndDetail);
        this.listenTo(eventBus, constants.EV_REFRESH_USER_GROUP_NODES_AND_DETAIL, this.refreshUserGroupNodesAndDetail);
        this.listenTo(eventBus, constants.EV_REFRESH_POSITION_NODES_AND_DETAIL, this.refreshPositionNodesAndDetail);
        this.listenTo(eventBus, constants.EV_REFRESH_LIST_NODES, this.refreshListNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_EMAIL_SERVER_NODES, this.refreshEmailServerNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_ACCOUNT_DETAILS, this.renderAccountDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_USER_DETAILS, this.renderUserDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_USER_GROUP_DETAILS, this.renderGroupDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_POSITION_DETAILS, this.renderUserPositionDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_LIST_DETAILS, this.renderListDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_EMAIL_SERVER_DETAILS, this.renderEmailServerDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_SYNCHRONIZE_DETAILS, this.renderSynchronizeDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_PERSONAL_DETAILS, this.renderPersonalDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_ARCHIVED_INSTANCE_DETAILS, this.renderArchivedInstancesDetailsView);
        this.listenTo(eventBus, constants.EV_REFRESH_NEW_ARCHIVE_DETAILS, this.renderNewArchiveDetailsView);
        this.listenTo(eventBus, constants.EV_OPEN_UNDELETED_USER_DETAILS, this.refreshTreeAndUserDetails);
        this.listenTo(eventBus, constants.EV_OPEN_UNDELETED_USER_GROUP_DETAILS, this.refreshTreeAndUserGroupDetails);
        this.listenTo(eventBus, constants.EV_OPEN_UNDELETED_USER_POSITION_DETAILS, this.refreshTreeAndUserPositionDetails);
        this.listenTo(eventBus, constants.EV_OPEN_UNDELETED_LIST_DETAILS, this.refreshTreeAndListDetails);
        this.listenTo(eventBus, constants.EV_OPEN_UNDELETED_EMAIL_SERVER_DETAILS, this.refreshTreeAndEmailServerDetails);

        if((userService.getUserType() === '1') || (!utils.isTrue(userService.checkPermissions('users')))){
            this.renderPersonalDetailsView();
        }
        return this;
    }

    _onDeletedUserGroup(){
        this.renderSearchUserGroups().then(()=>{
          console.log("Deleted User Group Left Panel");
          this.initializeTree();
          RestService.browseAllUsers().then((data) => {
            let items = userService.mapUsers(data, constants.USER_TYPE_GROUP);
            this.renderTreeNodes(items,constants.USERS_GROUP_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,"id","label","userGroupDetail");

          }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
          });
        });
    }

    _onDeletedPosition(){
        this.killDetailView(false,true)
       this.initializeTree();
        RestService.browseAllUsers().then((data) => {
            let items = userService.mapUsers(userPositionsResponse, constants.USER_TYPE_POSITION);
            this.renderTreeNodes(items,constants.USERS_POSITION_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,"id","label","userPositionDetail");

          }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
          });
    }

    _onDeleting(id){
        const $element = $(`a[data-itemid$='${id}']`);
        const itemId = $element.attr('data-itemid');
        $element.parent().remove();
        this.killDetailView(false, true);        
    }

    initializeTree(sectionContainer){
        console.log("Creating new resource");
        console.log("Is expanded",$(sectionContainer).is(':visible'));
            $(constants.ACCOUNT_SECTION_CONTAINER).collapse('show');
            if(sectionContainer===constants.USERS_GROUP_CONTAINER ||
                sectionContainer === constants.USERS_GROUP_GROUP_CONTAINER ||
                sectionContainer === constants.USERS_POSITION_GROUP_CONTAINER){
                this.initializeUsersNodes(constants.SETTINGS_USERS_GROUP_TYPE,constants.USERS_SECTION_CONTAINER);
                $(constants.USERS_SECTION_CONTAINER).collapse('show');
            }
            else {
                this.initializeResourcesNodes(constants.SETTINGS_RESOURCES_GROUP_TYPE,constants.RESOURCES_SECTION_CONTAINER);
                $(constants.RESOURCES_SECTION_CONTAINER).collapse('show');
            }
    }

    createNewUser(){
        this.initializeTree(constants.USERS_GROUP_CONTAINER);
        UserController.createNew(this).then().catch((err)=> {            
            NotificationService.error( err);
          });      
    }

    createNewUserGroup(){
        this.initializeTree(constants.USERS_GROUP_GROUP_CONTAINER);
        UserController.createNewUserGroup(this);
    }

    createNewUserPosition(){
          this.initializeTree(constants.USERS_POSITION_GROUP_CONTAINER);
          UserController.createNewUserPosition(this);
    }

    createNewEmailServer(){
        this.initializeTree(constants.EMAIL_SERVERS_GROUP_CONTAINER);
        sessionStorage.setItem("isNewServer", true);
        EmailServerController.createNew(this);

    }

    createNewList(){
        this.initializeTree(constants.LISTS_GROUP_CONTAINER);
        CustomListController.createNew(this);
    }

    openFromParams(params){
        $('a[data-itemid="' + params[1] + '"]').trigger('click');
        $('div[data-nodetype="' + params[2] + '"]').find("a").trigger('click');
        $('i[data-target="#' + params[3] + '"]').trigger('click');

        //Wait for the last click to load the servers
        setTimeout(() => {
            $('a[data-itemid="' + params[4] + '"]').trigger('click');
        }, 200);
       
    }


    renderExpandListDetailsView(listId){
        CustomListController.expandUpdatedCustomListAndDetailView(this,listId); 
    }
    onEmailServerDeleted(emailServerId){
        this.initializeTree();
        EmailServerController.expandUpdatedEmailServerListAndDetailView(this,emailServerId);
    }

    onCustomListDeleted(listId){
        this.initializeTree();
        CustomListController.expandUpdatedCustomListAndDetailView(this,listId);
    }

    onUserDeleted(userId) {
            const $element = $(`a[data-itemid$='${userId}']`);
            $element.parent().remove();
            this.cleanDetailView();
            NotificationService.success(`Deleted user. Clicking undo restores it.`);
    }

    refreshTreeAndUserDetails(userId){
        this.renderUserDetailsView(userId).then((result) =>{
            this._onUpdateUserOnTreeview(userId);
        });
    }

    refreshTreeAndUserGroupDetails(userGroupItem){
        this.renderGroupDetailsView(userGroupItem.id).then((result) =>{
            this._onUpdateUserGroupsOnTreeview(userGroupItem.id);
        });
    }

    refreshTreeAndUserPositionDetails(userPositionItem){
        this.renderUserPositionDetailsView(userPositionItem.id).then((result) =>{
            this._onUpdateUserPositionOnTreeview(userPositionItem.id);
        });
    }
    refreshTreeAndListDetails(listId){
       this.onCustomListDeleted(listId);
       $('#wellListsGroup').collapse('show');
    }

    refreshTreeAndEmailServerDetails(emailServerId){
        this.onEmailServerDeleted(emailServerId);
        $('#wellEmailsGroup').collapse('show');
    }
    

    cleanDetailView(){
        console.log("Cleaning Detail");
        // Cleaning Detail View here if no email Server Id was sent.
        // If no Details View is Called just show the updated tree.
        if (this.detailView) {
            this.detailView.$el.empty().off();
            /* off to unbind the events */
            this.detailView.stopListening();
        }
        //$('#wellEmailsGroup').collapse('show');
    }

    _onDetailUserSwitch(event) {
        if (event.detailPage === 'UserDetailsView') {
            this.renderUserDetailsView(event.payload.userId);
            // Finding the element so we can select it.
            let element = $(`a[data-itemid="${event.payload.userId}"]`);
            if (element) {
                // Removing previous selections.
                this.removeItemGroupSelection();

                // Selecting element.
                this.addItemGroupSelection(element);
            }
        } else if (event.detailPage === 'GroupDetailsView') {
            this.renderGroupDetailsView(event.payload.groupId);
            // Finding the element so we can select it.
            let element = $(`a[data-itemid="${event.payload.groupId}"]`);
            if (element) {
                // Removing previous selections.
                this.removeItemGroupSelection();
                // Selecting element.
                this.addItemGroupSelection(element);
            }
        }
    }

    _onDetailPositionSwitch(event) {
        this.renderUserPositionDetailsView(event.payload.positionId);
        // Finding the element so we can select it.
        let element = $(`a[data-itemid="${event.payload.positionId}"]`);
        if (element) {
            // Removing previous selections.
            this.removeItemGroupSelection();

            // Selecting element.
            this.addItemGroupSelection(element);
        }
    }

    _onUpdateUserOnTreeview(userId) {
        const dataTarget = '#wellusersGroup';
        const groupType = constants.SETTINGS_USERS_GROUP_TYPE;
        this.fillUsersOnTreeview(dataTarget, groupType,userId);
    }
    _onUpdateUserGroupsOnTreeview(userGroupId) {
      const dataTarget = '#welluserGroupsGroup';
      const groupType = constants.SETTINGS_USERS_GROUP_TYPE;
      this.fillUserGroupsOnTreeview(dataTarget, groupType,userGroupId);
    }

    _onUpdateUserPositionOnTreeview(positionId) {
      const dataTarget = '#wellpositionsGroup';
      const groupType = constants.SETTINGS_USERS_GROUP_TYPE;
      this.fillUserPositionsOnTreeview(dataTarget, groupType,positionId);
    }
    
    renderTreeNodes(data,
                    dataTarget,
                    groupType,
                    nodeIdField,
                    nodeNameField,
                    nodeTypeField,
                    icon = ICON_EMPTY,
                    hasChildren = false) {
        let dataArray = [];
        let nodes = [{
            nodeName: 'no items',
            url: '#',
            icon: ICON_EMPTY,
            id: 0,
            groupType: groupType,
            nodeType: '',
            hasChildren: false
        }];

        if (data) {
            dataArray = data instanceof Array ? data : [data];
            nodes = dataArray.map(item => {
                return {
                  nodeName: typeof item[nodeNameField]['#whitespace'] !== 'undefined' ? constants.USER_NAME_NOT_DEFINED_TEXT : item[nodeNameField],
                  url: '#',
                  icon: icon,
                  id: item[nodeIdField],
                  groupType: groupType,
                  nodeType: nodeTypeField,
                  hasChildren: hasChildren
                }
            });
        }        

        let group = {
            nodes: nodes
        };
        
        this.addItemsToGroup(group, dataTarget);
    }

    fillUsersOnTreeview(dataTarget, groupType,userId) {
        RestService.browseUsers().then((data) => {
            if (utils.isTrue(userService.checkPermissions('account')) && !listService.accountAPIEnabled){
                RestService.getAccountDetails().then((obj)=>{
                    listService.accountAPIEnabled = obj.APIEnabled;
                });
            }
            this.renderTreeNodes(data.User,dataTarget,groupType,"UserId","Name","user");
            if(userId){
              UserController.showWorkingNode(userId);
            }
        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    fillUserGroupsOnTreeview(dataTarget, groupType,userGroupId) {
        RestService.browseAllUsers().then((userGroupsResponse)=> {
          
        let items = userService.mapUsers(userGroupsResponse, constants.USER_TYPE_GROUP);
            
          this.renderTreeNodes(items,dataTarget,groupType,"id","label","userGroupDetail");
          if(userGroupId){
            UserController.showWorkingNode(userGroupId);
          }
        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    fillUserPositionsOnTreeview(dataTarget, groupType,positionId) {
        return RestService.browsePositions().then((userPositionsResponse) => {
          this.renderTreeNodes(userPositionsResponse.Position,dataTarget,groupType,"PositionId","Name","userPositionDetail");
          if(positionId){
              UserController.showWorkingNode(positionId);
          }
        }).catch((error) => {
          console.log(error);

          var msg = error || 'Unknown Error';
          NotificationService.error(msg);
        });
    }    

    handleSelectedGroup(ev) {
        if(this.detailView) {
            let subtitle = this.getSubtitle();
            const applyChangesElement = $('input[name="applyChanges"]'),
                confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.';

            utils.showConfirmationDashboardChangesModal(applyChangesElement, this.openSelectedGroup, confirmationText, subtitle, ev,this);
        }
        else{
            this.openSelectedGroup(ev)
        }
    }

    openSelectedGroup(ev){
        let divItems = $('div.bg-success');
        let liItems = $('li.bg-success');

        if (divItems) {
            divItems.removeClass('bg-success');
        }

        if (liItems) {
            liItems.removeClass('bg-success');
        }
         
        let  itemSelected = $(ev.currentTarget).parent().find('div.bo-body.collapse.in').find('.bg-success');
        if (itemSelected.length > 0){
            $(itemSelected[0]).removeClass('bg-success');
            listService.userItemSelected = undefined;
        }
        else{
            $(ev.currentTarget).addClass('bg-success');
        }
        
        var sectionType = ev.currentTarget.attributes['data-nodeType'].value;
        var id = ev.currentTarget.attributes['data-groupid'].value;
        let optionChosen = $(ev.currentTarget).text().trim();
        
        switch (optionChosen) {
            case 'Account Details':  // PF-1791 changes ref and def
                this.renderAccountDetailsView();
                break;
            case 'License':
                this.renderAccountLicenseView();
                break;
            case 'Personal Details':                
                this.renderPersonalDetailsView();
                break;
            case 'New Archive':
                this.renderNewArchiveDetailsView();
                break;
            case 'Archived Instances':
                this.renderArchivedInstancesDetailsView();
                break;
            default:
                this.processChildNodes(ev, sectionType);
        }

        this.activateSection(ev);
    }

    processChildNodes(ev, sectionType) {
        let id = ev.currentTarget.attributes['data-groupid'].value;
        let dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;
        if (new RegExp('collapsed').test(ev.currentTarget.children[1].className)) {
            var groupTypeId = id;           
            let nodes=[];
            let group;
            switch (sectionType) {

                case (this.sections.USERS):
                        this.initializeUsersNodes(groupTypeId,dataTarget);
                    break;

                case (this.sections.RESOURCES):
                    this.initializeResourcesNodes(groupTypeId,dataTarget);
                    break;
            }
        } 

        const icon = $('a[data-target="' + dataTarget + '"] i');
        const target = $(ev.currentTarget).find('.switch');

        util.togglePanel(target, icon);
    }

    initializeResourcesNodes(groupTypeId,dataTarget){
        let nodes = [
            {
                nodeName: 'Lists',
                icon: ICON_EMPTY,
                nodes: [],
                id: 'ListsGroup',
                groupType: groupTypeId,
                nodeType: 'listGroup',
                hasChildren: true,
                toggleIcon: 'pf-carot-left'
            },
            {
                nodeName: 'Email Servers',
                icon: ICON_EMPTY,
                nodes: [],
                id: 'EmailsGroup',
                groupType: groupTypeId,
                nodeType: 'emailGroup',
                hasChildren: true,
                toggleIcon: 'pf-carot-left'
            }           
        ];

        const hasConnPermissions = util.isTrue(userService.checkPermissions('connections'));
        const isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
        
        if(isBULicense && hasConnPermissions){
            nodes.push( {
                nodeName: 'Service URL',
                icon: ICON_EMPTY,
                nodes: [],
                id: 'serviceURL',
                groupType: groupTypeId,
                nodeType: 'serviceURLGroup',
                hasChildren: true,
                toggleIcon: 'pf-carot-left'
            });
        }

        // Update Model So It Will Be There Later, duh.
        let group = this.replaceGroupItemsInModel('settingsSections', 'Account Settings', groupTypeId, nodes);
        this.addItemsToGroup(group, dataTarget);
    }

    initializeUsersNodes(groupTypeId,dataTarget){
        let nodes = [
            {
                nodeName: 'Users',
                icon: ICON_EMPTY,
                nodes: [],
                id: 'usersGroup',
                groupType: groupTypeId,
                nodeType: 'users',
                hasChildren: true,
                toggleIcon: 'pf-carot-left'
            },
            {
                nodeName: 'User Groups',
                icon: ICON_EMPTY,
                nodes: [],
                id: 'userGroupsGroup',
                groupType: groupTypeId,
                nodeType: 'userGroup',
                hasChildren: true,
                toggleIcon: 'pf-carot-left'
            },
            {
                nodeName: 'Positions',
                icon: ICON_EMPTY,
                nodes: [],
                id: 'positionsGroup',
                groupType: groupTypeId,
                nodeType: 'positions',
                hasChildren: true,
                toggleIcon: 'pf-carot-left'
            },
            {
                nodeName: 'Synchronize',
                icon: ICON_SYNCRONIZE,
                nodes: [],
                id: 'synchronizeGroup',
                groupType: groupTypeId,
                nodeType: 'synchronize',
                hasChildren: false,
                toggleIcon: 'none'
            }
        ];

        // Update Model So It Will Be There Later, duh.
        let group = this.replaceGroupItemsInModel('settingsSections', 'Account Settings', groupTypeId, nodes);
        this.addItemsToGroup(group, dataTarget);
    }

    handleSelectedGroupItem(ev) {
        let spinner = $(".spinner").is(":visible");
        if (ev.type === 'click' && (!spinner)) {
            ev.preventDefault();
            try {
                ev.preventDefault();
            } 
            catch (e) {
                console.log("error", e);
            }
            
            if (this.detailView) {
                let subtitle = this.getSubtitle();
                const applyChangesElement = $('input[name="applyChanges"]'),
                    confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.';

                utils.showConfirmationDashboardChangesModal(applyChangesElement, this.openGroupDetailView, confirmationText, subtitle, ev, this);
            }
            else {
                this.openGroupDetailView(ev)
            }

            this.activateSection(ev);
        }
    }

    handleDblSelectedGroupItem(ev) {

        const target = $(ev.currentTarget);
        const nodeType = target.attr('data-nodetype');
        const groupType = target.attr('data-grouptype');
        const innerText = target.text();

        if (ev.type === 'dblclick' && nodeType !== 'group' && nodeType!=='' && nodeType!=='synchronize' && nodeType !== 'users'  && nodeType !== 'userGroup' && nodeType !=='positions' && nodeType !== 'listGroup' && nodeType !=='emailGroup' && ev.currentTarget.text!=='') {

            try {
                ev.preventDefault();
            } catch (e) {
                console.log("Error", e);
            }
           
            localStorage.setItem('oriVal', innerText);
            target.text('');
            $(utils.inputRenameTree(innerText)).appendTo(target).focus().select();
        }

        return false;
    }

    handleFocusOut(ev) {
        var $this = $(ev.currentTarget);
        var parent=$this.parent();
        let id = parent.attr('data-itemid');
        let name = $this.val().trim() || localStorage.getItem('oriVal');
        $this.parent().text(name);

        let link = $('a[data-itemid="'+ id +'"]');
        link.prop('title', name);
        let nodetype=parent.attr('data-nodetype');

        if ($this.val().trim() !== localStorage.getItem('oriVal').trim()) {
            if ($('#dashboard-left-panel .item-link').is(':disabled') === false) {
                $('#dashboard-left-panel .item-link').prop('disabled', true);
                if (nodetype === 'user') {
                    let firstName = name.split(' ')[0];
                    let lastName = name.split(' ')[1];

                    RestService.updateUserName(id, firstName, lastName).then(data => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        eventBus.trigger(constants.EV_REFRESH_USER_DETAILS, id);
                    }, err => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        console.log(`persistData upDateForm: ${restMessages.codeToMessage(err.CODE)}`);
                    });

                } else if (nodetype === 'userGroupDetail') {
                    RestService.updateUserGroupName(id, name).then(data => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        eventBus.trigger(constants.EV_REFRESH_USER_GROUP_DETAILS, id);
                    }, err => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        console.log(`persistData upDateForm: ${restMessages.codeToMessage(err.CODE)}`);
                    });

                } else if (nodetype === 'userPositionDetail') {
                    RestService.updatePositionName(id, name).then(data => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        eventBus.trigger(constants.EV_REFRESH_POSITION_DETAILS, id);
                    }, err => {
                        $('#dashboard-left-panel .item-link').prop('disabled', false);
                        console.log(`persistData upDateForm: ${restMessages.codeToMessage(err.CODE)}`);
                    });
                }
            }
        }

        $this.remove();
    }

    handleEnter(ev){
        var code = ev.keyCode || ev.which;
        if (code === 13) {
            ev.preventDefault();
            $(ev.currentTarget).blur();
        }
    }

    getSubtitle(){
        switch (this.detailView.model.constructor){
            case UserDetailsModel:
                if(this.detailView.model.get('groupDetails')) {
                    return `Settings - ${this.detailView.model.get('groupDetails').Name}`;
                }
                return `Settings - ${this.detailView.model.get('userDetails').FirstName} ${this.detailView.model.get('userDetails').LastName}`;
            case AccountSettingsModel:
                return `Settings - ${this.detailView.model.get('accountSettings').Name}`;
            case EmailServerDetailsModel:
                return `Settings - ${this.detailView.model.get('emailServerDetails').Name}`;
            case ListDetailsModel:
                return `Settings - ${this.detailView.model.get('listDetails').Name}`;
            case UserPositionDetailsModel:
                return `Settings - ${this.detailView.model.get('userPositionDetails').Name}`;
            case SynchronizationProfileModel:
                return `Settings - Synchronize Users with Directory Service`;
            case ListDetailsModel:
                return `Settings - ${this.detailView.model.get('listDetails').Name}`;
            case EmailServerDetailsModel:
                return `Settings - ${this.detailView.model.get('emailServerDetails').Name}`;
            case PersonalDetailsModel:
                return `Settings - ${this.detailView.model.get('personalDetails').FirstName} ${this.detailView.model.get('personalDetails').LastName}`;
            default:return ''

        }
    }

    openGroupDetailView(ev){
        console.log("Handling Selected Group Item 2");
        this.openGroupDetailViewConfirmation({target:ev.target, currentTarget:ev.currentTarget, targetAttributes:{
            'data-itemid': ev.currentTarget.attributes['data-itemid'].value,
            'data-groupType': ev.currentTarget.attributes['data-groupType'].value,
            'data-nodeType': ev.currentTarget.attributes['data-nodeType'].value
        }});
    }

    openGroupDetailViewConfirmation(o) {
        const itemId = o.targetAttributes['data-itemid'],
            groupType = o.targetAttributes['data-groupType'],
            nodeType = o.targetAttributes['data-nodeType'],
            formName = $(o.currentTarget).text();
        
            this.removeItemGroupSelection();
        this.addItemGroupSelection(o.target);
        
        const _users = () => {
            this.renderUsersDashboardView()
        };

        const _user = () => {
            this.renderUserDetailsView(itemId);
        };

        const _groups = () => {
            this.renderSearchUserGroups();
        };

        const _userGroupDetail = () => {
            this.renderGroupDetailsView(itemId);
        };

        const _emailServer= () => {
            sessionStorage.setItem("isNewServer", false);
            this.renderEmailServerDetailsView(itemId);
        };

        const _serviceURL= () => {
            this.renderServiceURLDetailsView(itemId);
        };

        const _list= () => {
            this.renderListDetailsView(itemId);
        };

        const _synchronizeDetail= () => {
            this.renderSynchronizeDetailsView();
        };

        const _userPositionDetail= () => {
            this.renderUserPositionDetailsView(itemId);
        };

        const _positions = () => {
            this.renderSearchPositionView();
        };

        const map = {
            'users': _users,
            'user': _user,
            'userGroup': _groups,
            'userGroupDetail': _userGroupDetail,
            'emailItem':_emailServer,
            'listItem':_list,
            'synchronize':_synchronizeDetail,
            'userPositionDetail':_userPositionDetail,
            'positions':_positions,
            'restSoapItem':_serviceURL
        };

        let setItemSelected = '';
        switch (nodeType) {
            case 'userPositionDetail':
                setItemSelected = 'userPosition';
            break; 
            case 'userGroupDetail':
                setItemSelected = 'userGroup';
            break;            
            case 'emailItem':
                setItemSelected = 'userEmail';
            break;
            case 'listItem':
                setItemSelected = 'userList';
            break;
            default: 
                setItemSelected = '';
            break;
        }

        listService.dashboardSettingsItems
            .setDefaultValue()
            .setPropValue(setItemSelected, {id: itemId, name: formName});
        
        let settingsSection = map[nodeType];

        if (settingsSection) {
            (settingsSection)();
        }
    }

    renderSearchPositionView(){
        this.killDetailView();
        utils.disableReloadLink();
        const positionName = '%';
        RestService.searchPositions(positionName).then((positionsData)=> {
            utils.enableReloadLink();
            let positionsModel = new PositionsModel();
            let positions = [];

            if (positionsData && positionsData.Positions) {
                positions = positionsData.Positions.Position instanceof Array ? 
                                        positionsData.Positions.Position : [positionsData.Positions.Position];
            }
           
            positionsModel.set('totalRecords', positions.length, {silent: true});           
            positionsModel.set('gridData', positions, {silent: true});
            
            // Search fields default values
            positionsModel.set('search-position', '', {silent: true});

            let breadcrumbs = [ 
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: 'General Position Information', route: '#generalPositionInformation'}
            ];
            
            positionsModel.set('dashboardTitle', 'Positions');
            positionsModel.set('breadcrumbs', breadcrumbs);

            let newDetailView = new PositionSearchDetailView({
                model: positionsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();

        }).catch((err=>{
            utils.enableReloadLink();
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ', err);
            NotificationService.error('Error retrieving positions. ' + errMsg);
        }));
    }

    renderUserPositionDetailsView(userPositionId){
        utils.disableReloadLink();
        this.killDetailView();
        return RestService.getUserPositionDetails(userPositionId).then((userPositionDetails)=> {
          utils.enableReloadLink();
          let userPositionDetailsModel=new UserPositionDetailsModel();
          let breadcrumbs = [
            {name: 'Settings', route: '#settings', id: 'goToSettings'},
            {name: 'Account Settings', id: 'goToAccountSettings'},
            {name: 'General Position Information', route: '#generalPositionInformation', id: 'goToPositionInformation'},
            {name: 'Position Details', route:'#positionDetails'}
          ];
          if($.isEmptyObject(userPositionDetails.MembersXML)){
              userPositionDetails.MembersXML={
                  "Members":{
                      "User":{}
                  }
              }
          }

          userPositionDetailsModel.set('dashboardTitle', 'Position Details');
          userPositionDetailsModel.set('breadcrumbs', breadcrumbs);
          userPositionDetailsModel.set('userPositionId', userPositionId);
          userPositionDetailsModel.set('userPositionDetails', userPositionDetails);
          userPositionDetailsModel.set('updatedUserPositionDetails', Object.assign({}, userPositionDetails));
          userPositionDetailsModel.set('addedUser', {"@id":'',"@label":''});

          listService.dashboardSettingsItems.setPropValue('userPosition', {id:userPositionId,name:userPositionDetails.Name});

            let newDetailView = new UserPositionDetailsView({
                model: userPositionDetailsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            
            listService.dashboardLayout.mainPanelView=newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((err=>{
          utils.enableReloadLink();
          console.log('Error retrieving new user position details view',err);
          NotificationService.error('Error retrieving new user position details view '+err.MESSAGE);
        }));
    }

    renderNewArchiveDetailsView(){
        utils.disableReloadLink();
        this.killDetailView();
        RestService.getFormList(constants.OWNER_INSTANCES_PERMISSION).then((formListData)=> {
            utils.enableReloadLink();
            let newArchiveModel=new NewArchiveModel();
            let breadcrumbs = [ 
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Archive Settings', id: 'goToArchiveSettings'},
                {name: 'New Archive'}
            ];
            newArchiveModel.set('breadcrumbs', breadcrumbs);
            let forms = (formListData.formsXML.forms && formListData.formsXML.forms.form) ? (formListData.formsXML.forms.form instanceof Array
                ? formListData.formsXML.forms.form
                : [formListData.formsXML.forms.form]) : [];
            newArchiveModel.set('formList',forms);
            newArchiveModel.set('isArchived',false);
            newArchiveModel.set('filterOptions',{
                status:'-1',
                name:'',
                dateOfFilter:'before',
                dateOfType:'first',
                firstSubmissionFrom:constants.DEFAULT_GROUP_ID,
                firstSubmissionTo:constants.DEFAULT_GROUP_ID,
                lastSubmissionFrom:constants.DEFAULT_GROUP_ID,
                lastSubmissionTo:constants.DEFAULT_GROUP_ID
            });

            newArchiveModel.set('filterFormList', []);

            let newDetailView = new NewArchiveDetailsView({
                model: newArchiveModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((err=>{
            utils.enableReloadLink();
            console.log('Error retrieving new archive details view',err);
            NotificationService.error('Error retrieving new archive details view '+err.MESSAGE);
        }));
    }

    renderArchivedInstancesDetailsView(){
        this.killDetailView();
        utils.disableReloadLink();
        RestService.getFormList(constants.OWNER_ARCHIVED_PERMISSION).then((formListData)=> {
            utils.enableReloadLink();
            let newArchiveModel = new NewArchiveModel();
            let breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Archive Settings', id: 'goToArchiveSettings'},
                {name: 'Archived Instances'}
            ];
            newArchiveModel.set('breadcrumbs', breadcrumbs);
            let forms=[];
            if(formListData.formsXML.forms) {
                forms = formListData.formsXML.forms.form instanceof Array
                    ? formListData.formsXML.forms.form
                    : [formListData.formsXML.forms.form];
            }
            else{
                formListData.formsXML.forms={form:[]};
                forms=formListData.formsXML.forms.form;
            }
            newArchiveModel.set('formList',forms);
            newArchiveModel.set('isArchived',true);
            newArchiveModel.set('filterOptions',{
                status:'-1',
                name:'',
                dateOfFilter:'before',
                dateOfType:'first',
                firstSubmissionFrom:constants.DEFAULT_GROUP_ID,
                firstSubmissionTo:constants.DEFAULT_GROUP_ID,
                lastSubmissionFrom:constants.DEFAULT_GROUP_ID,
                lastSubmissionTo:constants.DEFAULT_GROUP_ID
            });
            newArchiveModel.set('filterFormList',[]);

            let newDetailView = new NewArchiveDetailsView({
                model: newArchiveModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((err=>{
            utils.enableReloadLink();
            console.log('Error retrieving new archive details view',err);
            NotificationService.error('Error retrieving new archive details view '+err.MESSAGE);
        }));
    }

    renderUsersDashboardView(){
        this.killDetailView();
        utils.disableReloadLink();
        RestService.searchUsers().then((userData)=> {
            if (!listService.accountAPIEnabled){
                RestService.getAccountDetails().then((obj)=>{
                    listService.accountAPIEnabled = obj.APIEnabled;                    
                });
            }
            utils.enableReloadLink();
            let userSettingsModel = new UserSettingsModel();
            userSettingsModel.set('totalRecords', userData.TotalRecords, {silent: true});


            if (userData.UserList) {
                let users = userData.UserList.User instanceof Array
                    ? userData.UserList.User
                    : [userData.UserList.User];
                userSettingsModel.set('gridData', users, {silent: true});
            }
            else {
                userSettingsModel.set('gridData', [], {silent: true});
            }

            // Search fields default values
            userSettingsModel.set('search-firstName', '', {silent: true});
            userSettingsModel.set('search-lastName', '', {silent: true});
            userSettingsModel.set('search-email', '', {silent: true});
            userSettingsModel.set('search-domainUsername', '', {silent: true});
            userSettingsModel.set('search-customId', '', {silent: true});
            userSettingsModel.set('search-role', '-1', {silent: true});

            var breadcrumbs = [ 
                {name: 'Users', route: '#users'}
            ];

            userSettingsModel.set('dashboardTitle', 'Users');
            userSettingsModel.set('breadcrumbs', breadcrumbs);

            let newDetailView=  new UserSearchDetailView({
                model: userSettingsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView=newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((err=>{
            utils.enableReloadLink();
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ', err);
            NotificationService.error('Error while searching users. ' + errMsg);
        }));
    }

    renderSearchUserGroups() {
        this.killDetailView();
        utils.disableReloadLink();
        return RestService.browseAllUsers().then((userGroupData)=> {
            utils.enableReloadLink();
            let userSettingsModel = new UserSettingsModel();
            let userGroups = [];
           
            let items = userService.mapUsers(userGroupData, constants.USER_TYPE_GROUP);
          
            userSettingsModel.set('totalRecords', items.length, {silent: true});
            userSettingsModel.set('gridData', items, {silent: true});

            // Search fields default values
            userSettingsModel.set('search-groupName', '', {silent: true});

            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: constants.USER_GROUPS_SETTINGS_TITLE, route: '#userGroup'}
            ];

            userSettingsModel.set('dashboardTitle', constants.USER_GROUPS_SETTINGS_TITLE);
            userSettingsModel.set('breadcrumbs', breadcrumbs);

            let newDetailView = new UserGroupSearchDetailView({
                model: userSettingsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView=newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((err=>{
            utils.enableReloadLink();
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ', err);
            NotificationService.error('Error while searching user groups. ' + errMsg);
        }));
    }

    renderUpdatedServerDetails(emailServerId){
        console.log("Re-rendering server details for:",emailServerId);
        this.initializeTree();
        EmailServerController.expandUpdatedEmailServerListAndDetailView(this, emailServerId);
    }

    renderServiceURLDetailsView(id){
        utils.disableReloadLink();
        this.killDetailView();
        
        var breadcrumbs = [
            { name: 'Settings', route: '#settings', id: 'goToSettings' },
            { name: 'Resources', id: 'goToAccountSettings' },
            { name: 'REST/SOAP Service URL' }
        ];

        
        RestService.getWSSources().then((response)=> {
            utils.enableReloadLink();

            let data = [], limit = 0;

            if (response && response !== "") {

                if(response.WSSourcesList.WSSource){
                    data = response.WSSourcesList.WSSource;
                }
                
                limit = parseInt(response.WSSourcesList.WSSourcesLimit);

                if (!Array.isArray(data)) {
                    data = [data];
                }
            }

            const sourceURLTableModel = new Model({
                breadcrumbs: breadcrumbs,
                data: data,
                sourcesLimit: limit,
                accountName: listService.accountSettings.AccountName
            });

            let sourceView = new SourceURLTableView({
                model: sourceURLTableModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });
    
                listService.dashboardLayout.mainPanelView = sourceView;
                this.detailView = sourceView;
                this.detailView.render();
        }).catch((err=>{
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            NotificationService.error('Error Loading Service URL information. ' + errMsg);
        }));
    }

    renderEmailServerDetailsView(emailServerId){
        utils.disableReloadLink();
        this.killDetailView();
        RestService.getEmailServerDetails(emailServerId).then((response)=>{
            utils.enableReloadLink();

            let serverDetails=response.RESULT.RESPONSE;

            let emailServerDetailsModel = new EmailServerDetailsModel();
            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: 'Email Server Details'}
            ];

            if(!serverDetails.SecondaryEmailServerID){
                serverDetails.SecondaryEmailServerID = -1;
            }

            emailServerDetailsModel.set('breadcrumbs', breadcrumbs);
            emailServerDetailsModel.set('emailServerDetails', serverDetails);
            emailServerDetailsModel.set('hasChanges', false);
            emailServerDetailsModel.set('emailServerId',emailServerId);
            emailServerDetailsModel.set('currentEmailServerDetails', Object.assign({},serverDetails));

            let newDetailView = new EmailServerDetailsView({
                model: emailServerDetailsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardSettingsItems
                .setDefaultValue()
                .setPropValue('userEmail', {id: emailServerId, name: serverDetails.Name});

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();

            // Showing the tree after all the data loaded has finished
            //$('#wellEmailsGroup').collapse('show');
        }).catch((err=>{
            console.log('Error Email Server Details Data',err);
            NotificationService.error('Error Loading Email Server Details Data'+err.MESSAGE);
        }));
    }

    renderSynchronizeDetailsView(){
        this.killDetailView();
        utils.disableReloadLink();
        RestService.getSynchronizationProfile().then((synchronizationProfile)=> {
          utils.enableReloadLink();
          const synchronizationProfileModel = new SynchronizationProfileModel();

          const breadcrumbs = [
            {name: 'Settings', route: '#settings', id: "goToSettings"},
            {name: 'Account Settings', route: '#settings', id: "goToAccountSettings"},
            {name: 'Synchronize' }
          ];

          synchronizationProfileModel.set('dashboardTitle', 'Synchronize Users with Directory Service');
          synchronizationProfileModel.set('breadcrumbs', breadcrumbs);

          // PF-4027 Flag set in order to tell the application to not set a message XML on the syncronize button api call
          // as a result of an empty Synchronization Profile received from the backend.
          synchronizationProfileModel.set('isEmpty',synchronizationProfile ===  null);

          // PF-4027 Default values as if a single value is modified in the detail, the other XML values should be send as empty string.
          let synchronizationProfileObject = {
                  host: synchronizationProfile !== null ? synchronizationProfile.Connection["@host"] : "",
                  password: synchronizationProfile !== null ? synchronizationProfile.Connection["@password"] :"",
                  type: synchronizationProfile !== null ? synchronizationProfile.Connection["@type"] : "",
                  port: synchronizationProfile !== null ? synchronizationProfile.Connection["@port"] : "389",
                  useGlobal: synchronizationProfile !== null ? synchronizationProfile.Connection["@useGlobal"] : "",
                  useSSL: synchronizationProfile !== null ? synchronizationProfile.Connection["@useSSL"] : "",
                  username: synchronizationProfile !== null? synchronizationProfile.Connection["@username"] : "",

                  add: synchronizationProfile !== null ? synchronizationProfile.AutoSynch["@add"] : "",
                  change: synchronizationProfile !== null ? synchronizationProfile.AutoSynch["@change"] : "",
                  remove: synchronizationProfile !== null ? synchronizationProfile.AutoSynch["@remove"] : "",

                  context: synchronizationProfile !== null ? synchronizationProfile.LookUp["@context"] : "",
                  filter: synchronizationProfile !== null ? synchronizationProfile.LookUp["@filter"] : "",
                  objectClass: synchronizationProfile !== null ? synchronizationProfile.LookUp["@objectClass"] : "user",
                  subcontexts: synchronizationProfile !== null ? synchronizationProfile.LookUp["@subcontexts"] : "",

                  address1: synchronizationProfile !== null ? synchronizationProfile.Mappings["@address1"] : "",
                  address2: synchronizationProfile !== null ? synchronizationProfile.Mappings["@address2"] : "",
                  alternateEmail: synchronizationProfile !== null ? synchronizationProfile.Mappings["@alternateEmail"] :"",
                  cellphone: synchronizationProfile !== null ? synchronizationProfile.Mappings["@cellphone"] : "",
                  city: synchronizationProfile !== null? synchronizationProfile.Mappings["@city"] : "",
                  country: synchronizationProfile !== null ? synchronizationProfile.Mappings["@country"] : "",
                  customId: synchronizationProfile !== null ? synchronizationProfile.Mappings["@customId"] : "",
                  domainUsername: synchronizationProfile !== null ? synchronizationProfile.Mappings["@domainUsername"] : "",
                  domainUsernamePrefix: synchronizationProfile !== null ? synchronizationProfile.Mappings["@domainUsernamePrefix"] : "",
                  domainUsernameSuffix: synchronizationProfile !== null ? synchronizationProfile.Mappings["@domainUsernameSuffix"] : "",
                  email: synchronizationProfile !== null ? synchronizationProfile.Mappings["@email"] : "mail",
                  fax: synchronizationProfile !== null ? synchronizationProfile.Mappings["@fax"] : "",
                  firstName: synchronizationProfile !== null ? synchronizationProfile.Mappings["@firstName"] : "givenName",
                  guid: synchronizationProfile !== null ? synchronizationProfile.Mappings["@guid"] :"objectGUID",
                  lastName: synchronizationProfile !== null ? synchronizationProfile.Mappings["@lastName"] : "sn",
                  phone: synchronizationProfile !== null ? synchronizationProfile.Mappings["@phone"] : "",
                  position: synchronizationProfile !== null ? synchronizationProfile.Mappings["@position"] : "title",
                  skype: synchronizationProfile !== null ? synchronizationProfile.Mappings["@skype"] : "",
                  state: synchronizationProfile !== null ? synchronizationProfile.Mappings["@state"] : "",
                  userGroups: synchronizationProfile !== null ? synchronizationProfile.Mappings["@userGroups"] : "memberOf",
                  zipCode: synchronizationProfile !== null ? synchronizationProfile.Mappings["@zipCode"] : "",

                  allowSelfSignedCert: synchronizationProfile !== null ? synchronizationProfile.Options["@allowSelfSignedCert"] : "",
                  defaultUserStatus: synchronizationProfile !== null ? synchronizationProfile.Options["@defaultUserStatus"] :"",
                  includePositions: synchronizationProfile !== null ? synchronizationProfile.Options["@includePositions"] : "",
                  includeUserGroups: synchronizationProfile !== null ? synchronizationProfile.Options["@includeUserGroups"] : ""
              };

          synchronizationProfileModel.set('synchronizationProfile', Object.assign({}, synchronizationProfileObject));
          synchronizationProfileModel.set('currentSynchronizationProfile', Object.assign({}, synchronizationProfileObject));
          synchronizationProfileModel.set('hasChanges', false);

            let newDetailView = new SynchronizeDetailsView({
                model: synchronizationProfileModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();

        }).catch((err=>{
            utils.enableReloadLink();
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            NotificationService.error('Error Loading Synchronization Profile Data. ' + errMsg);
        }));
    }

    renderListDetailsView(listId){
        this.killDetailView();
        utils.disableReloadLink();
        return RestService.getCustomList(listId,true).then((listDetails)=>{
            utils.enableReloadLink();
            let listDetailsModel = new ListDetailsModel();
            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: "goToSettings"},
                {name: 'Account Settings', route: '#settings', id: "goToAccountSettings"},
                {name: 'List Details', route: undefined }
            ];

            listService.dashboardSettingsItems
                .setDefaultValue()
                .setPropValue('userList', {id: listId, name: listDetails.Name});

            if(listDetails.CustomListXML.CustomList){
                listDetails.CustomListXML.CustomList.Item = listDetails.CustomListXML.CustomList.Item instanceof Array
                    ? listDetails.CustomListXML.CustomList.Item
                    :[listDetails.CustomListXML.CustomList.Item];
            }

            listDetailsModel.set('breadcrumbs', breadcrumbs);
            listDetailsModel.set('hasChanges', false);
            listDetailsModel.set('currentCell', {});
            listDetailsModel.set('listId',listId);
            listDetailsModel.set('listDetails', Object.assign({},$.extend(true, {}, listDetails)));
            listDetailsModel.set('currentListDetails',$.extend(true, {}, listDetails));

            let newDetailView = new ListDetailsView({
                model: listDetailsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((err=>{
            utils.enableReloadLink();
            console.log('Error while showing list details view',err);
            NotificationService.error('Error while showing list details view'+(err.MESSAGE || ''));
        }));
    }

    renderUserDetailsView(userId) {        
        utils.disableReloadLink();
        return RestService.getUserDetails(userId).then((userDetails)=> {

            utils.enableReloadLink();
            this.killDetailView();
           
            let userDetailsModel = new UserDetailsModel();

            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: 'General User Information', route: '#users', id: 'goToUsersInfo'}, 
                {name: 'User Details', id: ''}];
            
            userDetails.GettingStarted = UserService.getUserSettings().get('_maShGS');

            userDetailsModel.set('dashboardTitle', 'User Details');
            userDetailsModel.set('breadcrumbs', breadcrumbs);
            userDetailsModel.set('hasChanges', false);

            userDetailsModel.set('userDetails', userDetails);
            userDetailsModel.set('updatedUserDetails', Object.assign({}, userDetails));


            let newDetailView =  new UserDetailsView({model: userDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});

            listService.dashboardLayout.mainPanelView=newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
            listService.userItemSelected = {userId:userDetails.UserId};
            return userDetails;
        }).catch((err=>{
            utils.enableReloadLink();
            console.log('Error Loading User Details Data',err);
            NotificationService.error('Error Loading User Details Data'+err.MESSAGE);
        }));
    }

    renderAccountDetailsView(ev) {

        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        utils.disableReloadLink();
        RestService.getAccountDetails().then((accountSettings)=> {
            utils.enableReloadLink();
            this.killDetailView();
            console.log('Account Settings', accountSettings);
            const accountSettingsModel = new AccountSettingsModel();

            const breadcrumbs = [
                {name: 'Settings', route: '#settings', id: "goToSettings"},
                {name: 'Account Settings', id: "goToAccountSettings"},
                {name: 'Account Details', id: '' }
            ];

            // PF-1791 -- was "User"
            accountSettingsModel.set('dashboardTitle', 'Account Details');
            accountSettingsModel.set('breadcrumbs', breadcrumbs);

            accountSettings.blockUser = accountSettings.FailedLoginsPermitted !== '0' ? 'True' : 'False';
            accountSettings.ForcePasswordChangeDays = !accountSettings.ForcePasswordChangeDays ? '0' : accountSettings.ForcePasswordChangeDays;
            accountSettings.forcePassword = accountSettings.ForcePasswordChangeDays !== '0' ? 'True' : 'False';

            accountSettingsModel.set('accountSettings', Object.assign({}, accountSettings));
            accountSettingsModel.set('currentAccountSettings', Object.assign({}, accountSettings));
            accountSettingsModel.set('hasChanges', false);

            let newDetailView = new AccountSettingsView({
                model: accountSettingsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView=newDetailView;

            this.detailView = newDetailView;
            this.detailView.render();
            listService.avoidDoubleClickOnDashboardTree = false;
        }).catch((err=>{
            utils.enableReloadLink();
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            NotificationService.error('Error Loading Account Settings Data. ' + errMsg);
        }));
    }

    renderAccountLicenseView() {
        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        RestService.getAccountDetails().then((accountSettings)=> {
            this.killDetailView();
            console.log('Account Settings', accountSettings);
            let accountSettingsModel = new AccountSettingsModel();

            const breadcrumbs = [
                {name: 'Settings', route: '#settings', id: "goToSettings"},
                {name: 'Account Settings', id: "goToAccountSettings"},
                {name: 'License', id: '' }
            ];

            accountSettingsModel.set('dashboardTitle', 'Account License Details');
            accountSettingsModel.set('breadcrumbs', breadcrumbs);
            accountSettingsModel.set('accountSettings', Object.assign({}, accountSettings));

            let newDetailView = new SettingsLicenseView({
                model: accountSettingsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();

            listService.avoidDoubleClickOnDashboardTree = false;
        }).catch((err => {
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            NotificationService.error('Error Loading License Information. ' + errMsg);
        }));
    }


    renderGroupDetailsView(groupId) {
        utils.disableReloadLink();
        this.killDetailView();
        return RestService.getGroupDetails(groupId).then((groupDetails)=> {
            utils.enableReloadLink();
            let userDetailsModel = new UserDetailsModel();

            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: constants.USER_GROUPS_SETTINGS_TITLE, id: 'goToUserGroups'},
                {name: "User Group Details", route: '#userGroup'}
            ];

            userDetailsModel.set('dashboardTitle', 'User-Group - ' + groupDetails.Name);
            userDetailsModel.set('breadcrumbs', breadcrumbs);
            userDetailsModel.set('groupId', groupId);
            userDetailsModel.set('groupDetails', $.extend(true,{}, groupDetails));
            userDetailsModel.set('updatedGroupDetails', $.extend(true,{}, groupDetails));
            listService.dashboardSettingsItems.setPropValue('userGroup', {id:groupId,name:groupDetails.Name});

            let newDetailView = new UserGroupDetailsView({model: userDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();
        }).catch((error)=> {
            utils.enableReloadLink();
            console.log(' Error', error);
            if (error.CODE === '75') {
                NotificationService.error('An error has ocurred. The maximum number of users with offline app filling enabled has been reached.')
            }
        });

    }

    renderPersonalDetailsView() {

        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        this.killDetailView();
        utils.disableReloadLink();
        const currentUserId=RestService.getProfile().UserId;
        RestService.getPersonalDetails(currentUserId).then((personalDetails)=> {
            utils.enableReloadLink();
            personalDetails.StateProvince=personalDetails.StateProvince ===`${constants.DEFAULT_GROUP_ID},${constants.DEFAULT_GROUP_ID}`
                ? constants.DEFAULT_GROUP_ID
                :personalDetails.StateProvince;
            console.log("Theses are the personal Details",personalDetails);
            let personalDetailsModel = new PersonalDetailsModel();
            personalDetails.oldPassword='';
            personalDetails.newPassword='';
            personalDetails.repeatPassword='';
            personalDetails.GettingStarted = !listService.userSettings.attributes ? 'False' : listService.userSettings.get('_maShGS');


            var breadcrumbs = [ 
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Personal Settings', id: 'goToPersonalSettings'}, 
                {name: "Personal details", route: '#userGroup'}
            ];

            personalDetailsModel.set('dashboardTitle', 'Personal Details - ' + personalDetails.FirstName + ' '+ personalDetails.LastName);
            personalDetailsModel.set('breadcrumbs', breadcrumbs);
            personalDetailsModel.set('userId', currentUserId);
            personalDetailsModel.set('personalDetails', $.extend(true,{}, personalDetails));
            personalDetailsModel.set('currentPersonalDetails', $.extend(true,{}, personalDetails));
            personalDetailsModel.set('hasChanges', false);

            let newDetailView = new PersonalDetailsView({model: personalDetailsModel, el: constants.DASHBOARD_MAIN_PANEL});

            listService.dashboardLayout.mainPanelView = newDetailView;
            this.detailView = newDetailView;
            this.detailView.render();

            listService.avoidDoubleClickOnDashboardTree = false;
        }).catch((err=>{
            utils.enableReloadLink();
            let errorMsg = 'Error displaying Personal Details. ' + (err.MESSAGE ? err.MESSAGE : err);
            console.log(errorMsg);
            NotificationService.error(errorMsg);
        }));
    }



    handleExpand(ev) {
        try {
            ev.preventDefault();

        let itemSelected;
        if (ev.currentTarget.nodeName === 'DIV'){
            itemSelected = $(ev.currentTarget).parent().find('div.document-body.collapse.in').find('.bg-success');
        }
        if (ev.currentTarget.nodeName === 'I'){
            itemSelected = $(ev.currentTarget.attributes['data-target'].value).find('.bg-success');
        }  
        if (itemSelected){    
           if (itemSelected.length > 0){
               $(itemSelected[0]).removeClass('bg-success');
               listService.userItemSelected = undefined;
           }  
        }

        console.log("Event expansion");
        let itemId = ev.currentTarget.attributes['data-itemid'].value;
        let groupType = ev.currentTarget.attributes['data-groupType'].value;
        let nodeType = ev.currentTarget.attributes['data-nodeType'].value;

        console.log("Item Id",itemId);
        console.log("Group Type",groupType);
        console.log("Node Type",nodeType);

        // don't process on the collapse
        if (new RegExp('collapsed').test(ev.currentTarget.className)) {
            const _none = () => {              
                this.handleSection(ev);
            };

            const _email = () => {
                this.processEmailServers(ev,groupType,itemId);
            };

            const _list = () => {
                this.processLists(ev,groupType,itemId);
            };

            const _serviceURL = () => {
                this.processServiceURL(ev,groupType,itemId);
            };

            const _users = () => {

                var dataTarget = ev.currentTarget.attributes['data-target'].value;
                switch (groupType) {
                    case constants.SETTINGS_USERS_GROUP_TYPE:
                        this.fillUsersOnTreeview(dataTarget, groupType);
                        break;
                }

            };

            const _userGroups = () => {
                var dataTarget = ev.currentTarget.attributes['data-target'].value;

                this.fillUserGroupsOnTreeview(dataTarget, groupType);
            };

          const _userPositions = () => {
            var dataTarget = ev.currentTarget.attributes['data-target'].value;

            this.fillUserPositionsOnTreeview(dataTarget, groupType);
          };


            console.log('NodeType', nodeType);
            const map = {'users': _users, 'userGroup': _userGroups, 'emailGroup': _email, 'none': _none,
                'synchronize': _none, 'positions': _userPositions, 'listGroup': _list, 'serviceURLGroup': _serviceURL};
            (map[nodeType])();
        } else {
            let dataTarget = ev.currentTarget.attributes['data-target'].value;            
            this.handleSection(ev)
        }

        let dataTarget = ev.currentTarget.attributes['data-target'].value;
        let domTarget = $('a[data-target="'+ dataTarget + '"] i');
        
        let currentTargetObj = $(ev.currentTarget);

        if(currentTargetObj.hasClass('document-heading')){
            util.togglePanel(currentTargetObj.find('.switch'), currentTargetObj.find('i'));
        }
        else{
            //In this case the target is the same as the icon
            util.togglePanel(currentTargetObj, currentTargetObj);
        }
        

        }catch(e) {
            console.error("Error while handling", e);
        }
    }

    processEmailServers(ev,groupType,itemId){
        var dataTarget = ev.currentTarget.attributes['data-target'].value;
        RestService.getEmailServers().then((data) => {
            EmailServerController.renderEmailServerItems(this,data,groupType,itemId,dataTarget);
        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    processServiceURL(ev,groupType,itemId){
        var dataTarget = ev.currentTarget.attributes['data-target'].value;
        ServiceURLController.renderSourceURL(this,null,groupType,itemId,dataTarget);

    }

    processLists(ev,groupType,itemId){
        var dataTarget = ev.currentTarget.attributes['data-target'].value;
        RestService.browseCustomList().then((data) => {
            console.log("Lists Data",data);
            CustomListController.renderListItems(this,data,groupType,itemId,dataTarget);

        }).catch((error) => {
            console.log(error);

            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    refreshUserNodesAndDetail(itemId,groupType,nodeType,dataTarget){
        utils.cleanChildNodes(dataTarget);
        utils.disableReloadLink();
        RestService.browseUsers().then((data) => {
            utils.enableReloadLink();
            this.renderTreeNodes(data.User,dataTarget,groupType,"UserId","Name","user");
            this.renderUsersDashboardView();
        }).catch((error) => {
            console.log(error);
            utils.enableReloadLink();    
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    refreshUserGroupNodesAndDetail(itemId,groupType,nodeType,dataTarget){
        utils.cleanChildNodes(dataTarget);
        utils.disableReloadLink();
        RestService.browseAllUsers().then((data) => {
            utils.enableReloadLink();
            let items = userService.mapUsers(data, constants.USER_TYPE_GROUP);
            this.renderTreeNodes(items,constants.USERS_GROUP_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,"id","label","userGroupDetail");
            this.renderSearchUserGroups();
          }).catch((error) => {
            console.log(error);
            utils.enableReloadLink();    
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
          });
    }

    refreshPositionNodesAndDetail(itemId,groupType,nodeType,dataTarget){
        utils.cleanChildNodes(dataTarget);
        utils.disableReloadLink();
        RestService.browseAllUsers().then((userPositionsResponse) => {
            utils.enableReloadLink();
            let items = userService.mapUsers(userPositionsResponse, constants.USER_TYPE_POSITION);
            this.renderTreeNodes(items,dataTarget,groupType,"id","label","userPositionDetail");
            this.renderSearchPositionView();
          }).catch((error) => {
            console.log(error);
            utils.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
          });
    }

    refreshListNodes(itemId,groupType,nodeType,dataTarget){
        utils.cleanChildNodes(dataTarget);
        utils.disableReloadLink();
        RestService.browseCustomList().then((data) => {
            utils.enableReloadLink();
            CustomListController.renderListItems(this,data,groupType,itemId,dataTarget);
        }).catch((error) => {
            console.log(error);
            utils.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    refreshEmailServerNodes(itemId,groupType,nodeType,dataTarget){
        utils.cleanChildNodes(dataTarget);
        utils.disableReloadLink();
        RestService.getEmailServers().then((data) => {
            utils.enableReloadLink();
            EmailServerController.renderEmailServerItems(this,data,groupType,itemId,dataTarget);
        }).catch((error) => {
            console.log(error);
            utils.enableReloadLink();
            var msg = error || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    render() {

        super.render();


        const params = util.navigateToPage;
        if (params) {
            //Wait for page to load
            setTimeout(() => {
                this.openFromParams(params);
            }, 200);
        }

        // render default view for this tab
        // this.detailView = new SettingsMainView({model: this.model, el: constants.DASHBOARD_MAIN_PANEL});
        // this.detailView.render();
    }

    _settingsDeleteModal(elm) {
        const $node = $(`i[data-target="${elm.target}"]`),
            params = {id: elm.itemid, name: $node.siblings('a').text().trim()};
        
        listService.dashboardSettingsItems.setDefaultValue();
        if ( _.include(['user', 'userGroupDetail', 'userPositionDetail', 'listItem', 'emailItem'], elm.nodetype) ) {
            
            this.openGroupDetailViewConfirmation({target:$(`a[data-target="${elm.target}"]`), currentTarget:$(`a[data-target="${elm.target}"]`), targetAttributes:{
                'data-itemid': elm.itemid,
                'data-groupType': elm.grouptype,
                'data-nodeType': elm.nodetype
            }});

            switch(elm.nodetype) {
                case 'user':
                    listService.dashboardSettingsItems.setPropValue('user', params);
                    dashboardService.deleteUserModal();
                    break;
                case 'userGroupDetail':
                    listService.dashboardSettingsItems.setPropValue('userGroup', params);
                    dashboardService.deleteUserGroup();
                    break;
                case 'userPositionDetail':
                    listService.dashboardSettingsItems.setPropValue('userPosition', params);
                    dashboardService.deleteUserPosition();
                    break;
                case 'listItem':
                    listService.dashboardSettingsItems.setPropValue('userList', params);
                    dashboardService.deleteUserList();
                    break;
                case 'emailItem':
                    listService.dashboardSettingsItems.setPropValue('userEmail', params);
                    dashboardService.deleteUserEmailServer();
                    break;
                default:
                    break;
            }
        }
    }
}

export default SettingsLeftPanelView;